export default __webpack_public_path__ + "static/media/employees_1.a93ebe7b.png";